import React, { useRef, useLayoutEffect, useReducer, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, convertObjectToArray, cssVar, isArray, milesNumber, truncate_string, removeEmojis } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_sliceGrouper from "@amcharts/amcharts5/plugins/sliceGrouper";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5locales_en_US from "@amcharts/amcharts5/locales/en_US";
import am5locales_es_ES from "@amcharts/amcharts5/locales/es_ES";

import ActionLink from '../builder/ActionLink.js';
import Select from '../builder/Select.js';
import Spinner from '../builder/Spinner.js';
import SectionTitle from '../builder/SectionTitle.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';

import ChartInfo from './ChartInfo.js';

const default_graph_styles = { width:'100%', height:'calc(100dvh - 185px)' };

const export_data = {
	pngOptions:{
		quality:0.8,
		maintainPixelRatio:true,
	},
	csvOptions:{
		addColumnNames:true,
	},
	useDefaultCSS:false,
	numberFormat: "#,###",
};

const setMenuExport = (intl) => {
	const default_menu_export = [];
	default_menu_export.push({type: "format",	format: "csv", label: intl.formatMessage({ id:"Export {type}" }, { type:intl.formatMessage({id:"CSV file"})})});
	default_menu_export.push({type: "format",	format: "png", label: intl.formatMessage({ id:"Export {type}" }, { type:intl.formatMessage({id:"Image"})})});
	default_menu_export.push({type: "format",	format: "pdf", label: intl.formatMessage({ id:"Export {type}" }, { type:"PDF"})});
	return default_menu_export;
}

let theme_colors = [
	am5.color("rgba( 123, 104, 238, 1)"),
	am5.color("rgba( 0, 100, 0, 1)"),
	//am5.color("rgba( 255, 250, 205, 1)"),
	am5.color("rgba( 199, 21, 133, 1)"),
	am5.color("rgba( 75, 0, 130, 1)"),
	//am5.color("rgba( 224, 255, 255, 1)"),
	am5.color("rgba( 186, 85, 211, 1)"),
	am5.color("rgba( 255, 0, 0, 1)"),
	am5.color("rgba( 153, 50, 204, 1)"),
	am5.color("rgba( 0, 255, 255, 1)"),
	am5.color("rgba( 135, 206, 250, 1)"),
	am5.color("rgba( 238, 130, 238, 1)"),
	am5.color("rgba( 255, 105, 180, 1)"),
	am5.color("rgba( 255, 250, 250, 1)"),
	am5.color("rgba( 106, 90, 205, 1)"),
	am5.color("rgba( 128, 128, 0, 1)"),
	am5.color("rgba( 0, 139, 139, 1)"),
	am5.color("rgba( 173, 216, 230, 1)"),
	am5.color("rgba( 255, 99, 71, 1)"),
	am5.color("rgba( 255, 239, 213, 1)"),
	am5.color("rgba( 218, 165, 32, 1)"),
	am5.color("rgba( 255, 228, 225, 1)"),
	am5.color("rgba( 205, 133, 63, 1)"),
	am5.color("rgba( 0, 255, 255, 1)"),
	am5.color("rgba( 0, 0, 255, 1)"),
	am5.color("rgba( 107, 142, 35, 1)"),
	am5.color("rgba( 64, 224, 208, 1)"),
	am5.color("rgba( 154, 205, 50, 1)"),
	am5.color("rgba( 102, 205, 170, 1)"),
	am5.color("rgba( 143, 188, 143, 1)"),
	am5.color("rgba( 128, 128, 128, 1)"),
	am5.color("rgba( 139, 69, 19, 1)"),
	am5.color("rgba( 0, 0, 139, 1)"),
	am5.color("rgba( 255, 20, 147, 1)"),
	am5.color("rgba( 178, 34, 34, 1)"),
	am5.color("rgba( 105, 105, 105, 1)"),
	am5.color("rgba( 124, 252, 0, 1)"),
	am5.color("rgba( 0, 128, 128, 1)"),
	am5.color("rgba( 127, 255, 0, 1)"),
	am5.color("rgba( 128, 0, 128, 1)"),
	am5.color("rgba( 255, 228, 196, 1)"),
	am5.color("rgba( 189, 183, 107, 1)"),
	am5.color("rgba( 255, 182, 193, 1)"),
	am5.color("rgba( 250, 235, 215, 1)"),
	am5.color("rgba( 255, 255, 240, 1)"),
	am5.color("rgba( 0, 0, 128, 1)"),
	am5.color("rgba( 255, 69, 0, 1)"),
	am5.color("rgba( 100, 149, 237, 1)"),
	am5.color("rgba( 255, 218, 185, 1)"),
	am5.color("rgba( 119, 136, 153, 1)"),
	am5.color("rgba( 240, 255, 240, 1)"),
	am5.color("rgba( 0, 255, 127, 1)"),
	am5.color("rgba( 255, 250, 240, 1)"),
	am5.color("rgba( 165, 42, 42, 1)"),
	am5.color("rgba( 253, 245, 230, 1)"),
	am5.color("rgba( 255, 215, 0, 1)"),
	am5.color("rgba( 250, 240, 230, 1)"),
	am5.color("rgba( 152, 251, 152, 1)"),
	am5.color("rgba( 230, 230, 250, 1)"),
	am5.color("rgba( 184, 134, 11, 1)"),
	am5.color("rgba( 95, 158, 160, 1)"),
	am5.color("rgba( 112, 128, 144, 1)"),
	am5.color("rgba( 47, 79, 79, 1)"),
	am5.color("rgba( 255, 245, 238, 1)"),
	am5.color("rgba( 127, 255, 212, 1)"),
	am5.color("rgba( 135, 206, 235, 1)"),
	am5.color("rgba( 47, 79, 79, 1)"),
	am5.color("rgba( 255, 248, 220, 1)"),
	am5.color("rgba( 169, 169, 169, 1)"),
	am5.color("rgba( 119, 136, 153, 1)"),
	am5.color("rgba( 72, 61, 139, 1)"),
	am5.color("rgba( 105, 105, 105, 1)"),
	am5.color("rgba( 245, 222, 179, 1)"),
	am5.color("rgba( 216, 191, 216, 1)"),
	am5.color("rgba( 128, 0, 0, 1)"),
	am5.color("rgba( 0, 191, 255, 1)"),
	am5.color("rgba( 30, 144, 255, 1)"),
	am5.color("rgba( 138, 43, 226, 1)"),
	am5.color("rgba( 248, 248, 255, 1)"),
	am5.color("rgba( 25, 25, 112, 1)"),
	am5.color("rgba( 128, 128, 128, 1)"),
	am5.color("rgba( 160, 82, 45, 1)"),
	am5.color("rgba( 32, 178, 170, 1)"),
	am5.color("rgba( 176, 224, 230, 1)"),
	am5.color("rgba( 210, 180, 140, 1)"),
	am5.color("rgba( 85, 107, 47, 1)"),
	am5.color("rgba( 192, 192, 192, 1)"),
	am5.color("rgba( 169, 169, 169, 1)"),
	am5.color("rgba( 60, 179, 113, 1)"),
	am5.color("rgba( 255, 222, 173, 1)"),
	am5.color("rgba( 139, 0, 0, 1)"),
	am5.color("rgba( 233, 150, 122, 1)"),
	am5.color("rgba( 245, 255, 250, 1)"),
	am5.color("rgba( 220, 20, 60, 1)"),
	am5.color("rgba( 219, 112, 147, 1)"),
	am5.color("rgba( 139, 0, 139, 1)"),
	am5.color("rgba( 0, 0, 205, 1)"),
	am5.color("rgba( 188, 143, 143, 1)"),
	am5.color("rgba( 211, 211, 211, 1)"),
	am5.color("rgba( 144, 238, 144, 1)"),
	am5.color("rgba( 220, 220, 220, 1)"),
	am5.color("rgba( 250, 128, 114, 1)"),
	am5.color("rgba( 0, 250, 154, 1)"),
	am5.color("rgba( 148, 0, 211, 1)"),
	am5.color("rgba( 255, 255, 224, 1)"),
	am5.color("rgba( 70, 130, 180, 1)"),
	am5.color("rgba( 211, 211, 211, 1)"),
	am5.color("rgba( 221, 160, 221, 1)"),
	am5.color("rgba( 255, 228, 181, 1)"),
	am5.color("rgba( 240, 255, 255, 1)"),
	am5.color("rgba( 46, 139, 87, 1)"),
	am5.color("rgba( 244, 164, 96, 1)"),
	am5.color("rgba( 255, 165, 0, 1)"),
	am5.color("rgba( 255, 160, 122, 1)"),
	am5.color("rgba( 240, 230, 140, 1)"),
	am5.color("rgba( 255, 140, 0, 1)"),
	am5.color("rgba( 245, 245, 245, 1)"),
	am5.color("rgba( 176, 196, 222, 1)"),
	am5.color("rgba( 255, 0, 255, 1)"),
	am5.color("rgba( 255, 0, 255, 1)"),
	am5.color("rgba( 255, 235, 205, 1)"),
	am5.color("rgba( 147, 112, 219, 1)"),
	am5.color("rgba( 255, 255, 0, 1)"),
	am5.color("rgba( 0, 206, 209, 1)"),
	am5.color("rgba( 240, 248, 255, 1)"),
	am5.color("rgba( 34, 139, 34, 1)"),
	am5.color("rgba( 218, 112, 214, 1)"),
	am5.color("rgba( 250, 250, 210, 1)"),
	am5.color("rgba( 255, 127, 80, 1)"),
	am5.color("rgba( 240, 128, 128, 1)"),
	am5.color("rgba( 255, 240, 245, 1)"),
	am5.color("rgba( 72, 209, 204, 1)"),
	am5.color("rgba( 210, 105, 30, 1)"),
	am5.color("rgba( 50, 205, 50, 1)"),
	am5.color("rgba( 205, 92, 92, 1)"),
	am5.color("rgba( 112, 128, 144, 1)"),
	am5.color("rgba( 173, 255, 47, 1)"),
	am5.color("rgba( 0, 255, 0, 1)"),
	am5.color("rgba( 222, 184, 135, 1)"),
	am5.color("rgba( 65, 105, 225, 1)"),
	am5.color("rgba( 255, 192, 203, 1)"),
	am5.color("rgba( 238, 232, 170, 1)"),
	am5.color("rgba( 175, 238, 238, 1)"),
	am5.color("rgba( 0, 128, 0, 1)"),
	am5.color("rgba( 245, 245, 220, 1)"),
]

/*for (let i = theme_colors.length - 1; i > 0; i--) {
	const j = Math.floor(Math.random() * (i + 1)); // Generar un índice aleatorio
	[theme_colors[i], theme_colors[j]] = [theme_colors[j], theme_colors[i]]; // Intercambiar los elementos
}*/
theme_colors.unshift(am5.color(`rgba(${cssVar('--ep-brand-color')}, 1)`),am5.color(`rgba(${cssVar('--ep-orange-color')}, 1)`));

const texts = {
	already:"Already participating page",
	average_games_user:"Average games per user",
	average_moves_game:"Average moves per game",
	average_time_game:"Average time per game",
	average_time_user:"Average time per user",
	brackets:"Brackets page",
	certificate:"Certificate of validity page",
	claim:"Claim your prize page",
	code_validator:"Validation code page",
	custom_section:"Custom section page",
	email_validation:"Email validation page",
	entries:"Gallery page",
	entries_ranking:"Ranking page",
	formadd:"Registration form page",
	gallery_ranking:"Gallery ranking page",
	gallery_view:"Gallery page",
	gallery_voteme:"Individual entry in gallery page",
	loyalty_cards:"Loyalty Card",
	loyalty_shop:"Loyalty Shop",
	login:"Login page",
	my_participation:"My participation",
	my_prizes:"My prizes",
	my_rewards:"My rewards",
	not_allowed:"Not allowed access page",
	participate:"Participation",
	promoview:"Welcome page",
	quiz:"Quiz page",
	redeem:"Redemption page",
	roulette:"Roulette page",
	share:"Sharing page",
	stage_mosaic:"Participation stages page",
	stage_result:"Participation stage result page",
	stage_state:"Participation stage state page",
	success:"Final page",
	total_played:"Total Games played",
	vote_validation:"Vote validation page",
	voteme:"Individual entry page",
	winners:"Winners page",
	positive:"Awarded coins",
	negative:"Spent coins",
	promotion:"Promotion",
	multi:"Multi-Network",
	list:"Pick-a-winner App",
	live:"Event Giveaway",
	sent:"***Sent",
	opens:"***Opens",
	clicks:"Clicks",
	rejects:"***Rejects",
};

const getCategoryColor = (category, index) => {
	if(category.toLowerCase().includes('Youtube'.toLowerCase())) return am5.color(`rgba(${cssVar('--youtube-color')}, 1)`);
	if(category.toLowerCase().includes('Facebook'.toLowerCase())) return am5.color(`rgba(${cssVar('--facebook-color')}, 1)`);
	if(category.toLowerCase().includes('WhatsApp'.toLowerCase())) return am5.color(`rgba(${cssVar('--whatsapp-color')}, 1)`);
	if(category.toLowerCase().includes('Twitter'.toLowerCase())) return am5.color(`rgba(${cssVar('--twitter-color')}, 1)`);
	if(category.toLowerCase().includes('Instagram'.toLowerCase())) return am5.color(`rgba(${cssVar('--instagram-color')}, 1)`);
	if(category.toLowerCase().includes('LinkedIn'.toLowerCase())) return am5.color(`rgba(${cssVar('--linkedin-color')}, 1)`);
	if(category.toLowerCase().includes('Telegram'.toLowerCase())) return am5.color(`rgba(${cssVar('--telegram-color')}, 1)`);
	if(category.toLowerCase().includes('Line'.toLowerCase())) return am5.color(`rgba(${cssVar('--line-color')}, 1)`);
	if(category.toLowerCase().includes('Pinterest'.toLowerCase())) return am5.color(`rgba(${cssVar('--pinterest-color')}, 1)`);
	if(category.toLowerCase().includes('Threads'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-black-color')}, 1)`);
	if(category.toLowerCase().includes('Tiktok'.toLowerCase())) return am5.color(`rgba(${cssVar('--tiktok-color')}, 1)`);
	if(category.toLowerCase().includes('Twitch'.toLowerCase())) return am5.color(`rgba(${cssVar('--twitch-color')}, 1)`);
	if(category.toLowerCase().includes('Email'.toLowerCase())) return am5.color(`rgba(${cssVar('--mail-color')}, 1)`);
	if(category.toLowerCase().includes('Google'.toLowerCase())) return am5.color(`rgba(${cssVar('--google-color')}, 1)`);
	if(category.toLowerCase().includes('Accepted'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-green-color')}, 1)`);
	if(category.toLowerCase().includes('Blocked'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-red-color')}, 1)`);
	if(category.toLowerCase().includes('Pending'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-orange-color')}, 1)`);
	if(category.toLowerCase().includes('Total'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-darkgray-color')}, 1)`);
	if(category.toLowerCase().includes('Mobile'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-lightblue-color')}, 1)`);
	if(category.toLowerCase().includes('Desktop'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-darkgray-color')}, 1)`);
	if(category.toLowerCase().includes('iPhone'.toLowerCase())) return am5.color(`rgba(192, 192, 192, 1)`);
	if(category.toLowerCase().includes('Android'.toLowerCase())) return am5.color(`rgba(57, 255, 20, 1)`);
	if(category.toLowerCase().includes('iPad'.toLowerCase())) return am5.color(`rgba(66, 66, 66, 1)`);
	if(category.toLowerCase().includes('widget'.toLowerCase())) return am5.color(`rgba(0, 191, 255, 1)`);
	if(category.toLowerCase().includes('Referral'.toLowerCase())) return am5.color(`rgba(0, 100, 0, 1)`);
	if(category.toLowerCase().includes('Direct'.toLowerCase())) return am5.color(`rgba(0, 0, 139, 1)`);
	if(category.toLowerCase().includes('Other'.toLowerCase())) return am5.color(`rgba(192, 192, 192, 1)`);
	if(category.toLowerCase().includes('Chrome'.toLowerCase())) return am5.color(`rgba(0, 0, 139, 1)`);
	if(category.toLowerCase().includes('Edge'.toLowerCase())) return am5.color(`rgba(0, 0, 128, 1)`);
	if(category.toLowerCase().includes('Firefox'.toLowerCase())) return am5.color(`rgba(255, 0, 0, 1)`);
	if(category.toLowerCase().includes('Safari'.toLowerCase())) return am5.color(`rgba(0, 191, 255, 1)`);
	if(category.toLowerCase().includes('Opera'.toLowerCase())) return am5.color(`rgba(139, 0, 0, 1)`);
	if(category.toLowerCase().includes('UCBrowser'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-orange-color')}, 1)`);
	if(category.toLowerCase().includes('positive'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-green-color')}, 1)`);
	if(category.toLowerCase().includes('negative'.toLowerCase())) return am5.color(`rgba(${cssVar('--ep-red-color')}, 1)`);

	return theme_colors[index];
}

const getGraphTitle = (type,intl) => {
	const i18n = (m, c) => i18nIntl(m, intl, c);
	const type_parts = type.split("|");
	const section = type_parts[0];
	const subsection = type_parts[1];
	let _type ='';

	if(section == 'qos'){
		switch(subsection) {
			case 'date':
				return i18n("200 requests last month, daily (avg ms)");
			case 'date_total':
				return i18n("200 requests last month, daily total");
			case 'hourly':
				return i18n("200 requests last 7 days, hourly (avg ms)");
			case 'hourly_total':
				return i18n("200 requests last 7 days, hourly total");
			case 'detailed':
				return i18n("200 requests in last day, every 5 minutes (avg ms)");
			case 'detailed_total':
				return i18n("200 requests in last day, every 5 minutes total");
			case 'month':
				return i18n("200 requests, monthly (avg ms)");
			case 'month_total':
				return i18n("200 requests, monthly total");
			case 'year_total':
				return i18n("200 requests, yearly total");
			case 'date500':
				return i18n("500 requests, daily (num/million total requests)");
			case 'month500':
				return i18n("500 requests, monthly (num/million total requests)");
			case 'hourly500':
				return i18n("500 requests, hourly (num/million requests)");
			case 'year':
				return i18n("200 requests, yearly (avg ms)");
			case 'year500':
				return i18n("500 requests, yearly (num/million total requests)");
			case 'hourly500total':
				return i18n("500 requests, hourly total");
			case 'date500total':
				return i18n("500 requests, daily total");
			case 'month500total':
				return i18n("500 requests, monthly total");
			case 'year500total':
				return i18n("500 requests, yearly total");
		}
	}

	if(['promofluxstatsbyparticipation','promotypestats','promofluxstats','promotypestatsbyparticipation'].includes(section)){//Stats de Promotions a Overlord

		let title = '';
		switch (section) {
			case 'promotypestats':
				title = 'Promotions by Type';
				break;
			case 'promofluxstats':
				title = 'Type of Flow';
				break;
			case 'promofluxstatsbyparticipation':
				title = 'Type of Flow Participations';
				break;
			case 'promotypestatsbyparticipation':
				title = 'Promotion Type Participations';
				break;
		}
		switch(subsection) {
			case 'month':
				return intl.formatMessage({ id:"{label}, Month by Month"},{label:title});
				break;
		}
	}

	if(section == 'participants' || section == 'uniq_participants'){//Givewaway
		const title = (section == 'uniq_participants') ? i18n("Unique") : i18n("Totals");
		switch(subsection) {
			case 'date':
				return intl.formatMessage({ id:"{label} per day"},{label:title});
			case 'hour':
				return intl.formatMessage({ id:"{label} per hour"},{label:title});
			case 'hourly':
				return intl.formatMessage({ id:"{label} - Last 7 days per hour"},{label:title});
			case 'network':
				return intl.formatMessage({ id:"{label} by social network"},{label:title});
			case 'top':
				return intl.formatMessage({ id:"More active"});
		}
	}

	if(section == 'sweep'){//Givewaway
		const title = i18n("Totals");
		switch(subsection) {
			case 'total':
				return intl.formatMessage({ id:"By number of completed draws"},{label:title});
			case 'total_candidates':
				return intl.formatMessage({ id:"By number of finalists"},{label:title});
		}
	}

	switch(subsection) {
		case 'date':
		case 'download_date':
			return i18n("Day by day");

		case 'hourly':
			return i18n("Last 7 days, hourly");

		case 'device':
			return i18n("Devices");

		case 'direct_vs_recruit':
			return i18n("Direct users vs Recruited users");

		//case 'download_date':
		//	return "";

		//case 'especific_alerts':
		//	return "";

		case 'ep1':
			return i18n("Total sources");

		case 'generic':
			return i18n("Main information");

		case 'totals':
			return i18n("Totals");

		case 'all_mail_domains':
			return i18n("Email Domains");

		case 'non_generic_mail_domains':
			return i18n("Non generic Email Domains");

		case 'table_rate':
			return i18n("Coupon Redemption Rate");

		case 'hour':
			return i18n("Hour of the day");

		case 'login':
			return i18n("Social Login");

		case 'mobile':
			return i18n("Desktop vs Mobile");

		case 'network':
		case 'total':
		case 'type':
			return i18n("Totals");

		case 'resume':
			return i18n("Resumed generic information");

		case 'week':
			return i18n("Day of the week");

		case 'average_moves_game':
			return i18n("Average moves in the game");

		case 'countries':
			return i18n("Country of connection");

		case 'browsers':
			return i18n("Browser type");

		case 'ages':
			return i18n("Ages");

		case 'utm_source':
			return i18n("By origin");

		case 'utm_campaign':
			return i18n("By campaign");

		case 'sources':
			return `${i18n("Type")}: ${i18n("Validation Portal vs Slider")}`;

		case 'prizes_week':
			return intl.formatMessage({ id:"Day of the week per {type}" }, { type:i18n("Prize Type") });

		case 'prizes_hour':
			return intl.formatMessage({ id:"Hour of the day per {type}" }, { type:i18n("Prize Type") });

		case 'sites_date':
			return intl.formatMessage({ id:"Day by day per {type}" }, { type:i18n("Validation Point") });

		case 'prizes_date':
			return intl.formatMessage({ id:"Day by day per {type}" }, { type:i18n("Prize Type") });

		case 'sites':
			return intl.formatMessage({ id:"Totals per {type}" }, { type:i18n("Validation Point") });
			
		case 'prizes_total':
			return intl.formatMessage({ id:"Totals per {type}" }, { type:i18n("Prize Type") });

		default:
			return `__${subsection}__`;
	}
};

const ChartSelector = (props) => {
	const _graphs = props?.graphs ?? {};
	const _state = props?.state ?? {};

	let _graphs_selector = [];
	for(const graph in _graphs) {
		_graphs_selector.push({ k:graph, v:getGraphTitle(_graphs[graph].title,props.intl) });
	}
	if(_graphs_selector.length < 2) {
		return null;
	}
	
	return (
		<Select
			value={_state.graph}
			values={_graphs_selector}
			autotranslate_options={false}
			change={(k, graph) => props.dispatch({ type:'SET_GRAPH', graph })}
			_class={{ first:true }}
			_field_style={{ flexGrow:'1' }}
		/>
	)
};

const Wrapper = (props) => {
	const display_header = props?.display_header ?? true;

	if(display_header === false) {
		return (
			props.children
		)
	}

	return (
		<div class="title_with_filter">
			<SectionTitle
				_class={{ icon:props?.active?.icon ?? 'knk-stats' }}
			>{props?.active?.title ?? 'Easypromos'}</SectionTitle>

			{props.children}
		</div>
	)
};

const ChartWrapper = (props) => {
	return (
		<>
			<Wrapper
				display_header={props.display_header}
				active={props.active}
			>
				<ChartInfo
					{...props}
				/>

				<div class="filter gui_actions gui_flex_end">
					<div class="stats-export" id={`export-${props?.active?.id ?? 'unknown'}`} />
					<ChartSelector {...props} />
				</div>
			</Wrapper>

			{props.children}
		</>
	)
};

const mainChartSetup = (type, init_callback, loaded_callback) => {
	let timeout;
	let timeout2;

	const loadedChart = () => {
		if (timeout) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(() => {
			root.events.off("frameended", loadedChart);
			//console.log(`${type} ready!`);
			if(loaded_callback != undefined){
				loaded_callback(type, true);
			}
		}, 100)
	}

	const initChart = () => {
		if (timeout2) {
			clearTimeout(timeout2);
		}
		timeout2 = setTimeout(() => {
			root.events.off("framestarted", initChart);
			//console.log(`${type} init!`);
			if(init_callback != undefined){
				init_callback(type, false);
			}
		}, 100)
	}

	let root = am5.Root.new(type);
	root.locale = (window.is_spanish) ? am5locales_es_ES : am5locales_en_US;
	root.locale.firstDayOfWeek = parseInt(window?.week_start ?? '1');
	///root.timezone = am5.Timezone.new("GMT");
	///root.utc = true;
	root.events.on("frameended", loadedChart);
	root.events.on("framestarted", initChart);

	root.setThemes([am5themes_Animated.new(root)]);
	root.dateFormatter.setAll({
		dateFields:['valueX'],
		timeZone: "UTC"
	});

	// List of available color properties in AmCharts 5:
	// https://www.amcharts.com/docs/v5/concepts/colors-gradients-and-patterns/#List_of_purposes
	root.interfaceColors.set('grid', am5.color(`rgba(${cssVar('--main-text-color')}, 1)`));
	root.interfaceColors.set('text', am5.color(`rgba(${cssVar('--main-text-color')}, 1)`));

	return root;
};

const PieChart = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const graph = props.state?.graph ?? false;
	let data_graph = props.data;
	data_graph.map((item,i) => {
		data_graph[i].value = parseFloat(item.value);
		const _name = truncate_string((removeEmojis(item.name)).trim(),60).replace(/\r?\n/g, " ");
		data_graph[i].name = i18n(((texts[_name] != undefined) ? texts[_name] : _name), 'ucfirst');
		const color = getCategoryColor(_name, i);
		data_graph[i].fill = color;
	})
	const pie_seriesRef = useRef(null);
	const legend_seriesRef = useRef(null);
	let root;	

	//theme_colors.unshift(am5.color(`rgba('192, 192, 192, 1')`));//per posarli color especific al other
	useLayoutEffect(() => {
		if(!am5.Root) return;

		root = mainChartSetup(props?.name ?? 'pie_chart', props.initChart, props.loadedChart);

		let chart = root.container.children.push(
			am5percent.PieChart.new(root, {
				layout:root.horizontalLayout,
			})
		);

		pie_seriesRef.current = chart.series.push(
			am5percent.PieSeries.new(root, {
				valueField:'value',
				categoryField:'name',
				fillField:'fill',
				legendLabelText:'{category}:',
				legendValueText:'[bold]{value}[/] ({valuePercentTotal.formatNumber("0.00p")})',
				tooltip:am5.Tooltip.new(root, {
					labelText:'[bold]{name}[/]: {value} ({valuePercentTotal.formatNumber("0.00p")})',
				}),
			})
		);
		
		//pie_seriesRef.current.get('colors').set('colors', theme_colors);

		const enable_export = props?.export ?? true;
		if(enable_export){
			let exporting = am5plugins_exporting.Exporting.new(root, {
				menu: am5plugins_exporting.ExportingMenu.new(root, {
					align:'left',
				}),
				dataSource: data_graph,
				numericFields: ['value'],
				filePrefix:props?.name ?? 'chart',
				dataFields: {"name":i18n("Type"),'value':i18n("Total")},
				dataFieldsOrder: ["name","value"],
				...export_data
			});
			exporting.get("menu").set("items", setMenuExport(props.intl));
		}

		legend_seriesRef.current = chart.children.push(am5.Legend.new(root, {
			centerX:am5.percent(50),
			centerY:am5.percent(50),
			y:am5.percent(50),
			x:am5.percent(75),
			layout:root.verticalLayout,
		}));

		// make the legend color to be circles:
		legend_seriesRef.current.markerRectangles.template.setAll({
			cornerRadiusTL:10,
			cornerRadiusTR:10,
			cornerRadiusBL:10,
			cornerRadiusBR:10,
		});
		
		return () => {
			root.dispose();
		};
	}, [ graph ]);

	useLayoutEffect(() => {
		pie_seriesRef.current.data.setAll(data_graph);

		legend_seriesRef.current.data.setAll(pie_seriesRef.current.dataItems);

		const minSlices = 3;
		if(data_graph.length >= minSlices) {
			const sliceGrouper = am5plugins_sliceGrouper.SliceGrouper.new(root, {
				series:pie_seriesRef.current,
				groupName:i18n("Other"),
				clickBehavior: 'zoom',
				legend:legend_seriesRef.current,
				threshold:3,
  				limit:props?.limit_slices ?? 30,
			});
		}

		pie_seriesRef.current.ticks.template.setAll({
			location:0.8,
			strokeWidth:2,
			forceHidden:true,
			stroke:am5.color(`rgba(${cssVar('--main-text-color')}, 1)`),
		});

		pie_seriesRef.current.slices.template.setAll({
			stroke:am5.color(`rgba(${cssVar('--main-bg-color')}, 1)`),
			strokeWidth:2,
		});

		pie_seriesRef.current.labels.template.setAll({
			fontSize:'1.1em',
			forceHidden:true,
			text:'{name}',
		});
	}, [ props.data ]);

	return (
		<div id={props?.name ?? 'pie_chart'} class="custom-graph" style={props?.graph_styles ?? default_graph_styles} />
	)
};

const LineChart = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const graph = props.state?.graph ?? false;
	const has_ranking = props?.promotion?.has_ranking ?? false;
	const data_graph = props.data;

	const title = props?.title ?? null;
	const xAxisRef = useRef(null);
	const xy_seriesRef = useRef([]);
	let root;
	
	const has_negative_values = (props?.active?.key ?? null) == 'coins';

	const type_parts = title.split("|");
	const graph_type = type_parts[1];

	const isWeekend = (date) => {
		switch(parseInt(window.week_start)) {
			case 6:
				// arab world (weekend being Friday and Saturday)
				return (date.getDay() == 5 || date.getDay() == 6) ? true : false;

			default:
				// rest of the world (weekend being Satuday and Friday)
				return (date.getDay() == 6 || date.getDay() == 0) ? true : false;
		}
	};

	useLayoutEffect(() => {
		if(!am5.Root) return;
		root = mainChartSetup(props?.name ?? 'line_chart', props.initChart, props.loadedChart);
		root.setThemes([am5themes_Animated.new(root)]);
		var easing = am5.ease.linear;
		let chart = root.container.children.push(
			am5xy.XYChart.new(root, {
				panX:false,
				panY:false,
				zoomX:false,
				zoomY:false,
				pinchZoomX:false,
				pinchZoomY:false,
				maxTooltipDistance:0,
				layout:root.horizontalLayout,
			})
		);

		let yAxis = chart.yAxes.push(
			am5xy.ValueAxis.new(root, {
				extraMax:0.05,
				min:has_negative_values ? null : 0,
				renderer:am5xy.AxisRendererY.new(root, {}),
			})
		);
		
		let _xAxisDateFormat = "dd/MMM/YYYY";
		let _baseInterval = {timeUnit:'day',count:1};
		switch(graph_type){
			case 'hourly':
			case 'hourly500':
			case 'hourly500total':
			case 'hourly_total':
				_baseInterval = {timeUnit:'hour',count:1};
				_xAxisDateFormat = "dd/MMM/YYYY HH a";
				break;
			case 'month':
			case 'month500':
			case 'month500total':
			case 'month_total':
				_baseInterval = {timeUnit:'month',count:1};
				_xAxisDateFormat = "MMM/YYYY";
				break;
			case 'minute':
			case 'detailed':
			case 'detailed_total':
				_baseInterval = {timeUnit:'minute',count:1};
				_xAxisDateFormat = "dd/MMM/YYYY HH:mm";
				break;
		}

		let xAxis = chart.xAxes.push(
			am5xy.DateAxis.new(root, {
				baseInterval:_baseInterval,
				maxDeviation: 0.1,
    			groupData: false,
				fillRule:(dataItem) => {
					const axisFill = dataItem.get('axisFill');
					const date = new Date(dataItem.get('value'));
					axisFill.setPrivate('visible', (_baseInterval.timeUnit == 'day') ? isWeekend(date) : false);
				},
				renderer:am5xy.AxisRendererX.new(root, {
					minGridDistance:40,
				}),
				tooltip: am5.Tooltip.new(root, {
				})
			}),
		);

		xAxis.get("tooltipDateFormats").day = _xAxisDateFormat;
		let xRenderer = xAxis.get('renderer');
		xRenderer.axisFills.template.setAll({
			fill:am5.color(`rgba(${cssVar('--main-text-color')}, 0.1)`),
			visible:true,
		});

		let categories = [];
		data_graph.map((object) => {
			for(const property in object) {
				if(property == 'name') continue;
				if(categories.indexOf(property) >- 1) continue;
				categories.push(property);
			}
		});
		let totalIndex = categories.indexOf("Total");
		if (totalIndex !== -1) {
			categories.splice(totalIndex, 1);
			categories.unshift("Total");//posem Total a dalt de tot
		}
		let positiveCoinsIndex = categories.indexOf("positive");//posem Positive a dalt de tot
		if (positiveCoinsIndex !== -1) {
			categories.splice(positiveCoinsIndex, 1);
			categories.unshift("positive");
		}

		const enable_export = props?.export ?? true;
		if(enable_export){
			const categories_export = Object.fromEntries(categories.map((valor, index) => [`${valor}`, (!['Total','Accepted'].includes(valor) ? `"${i18n(valor)}"` : i18n(valor))]));
			const keys_export = [...new Set(data_graph.flatMap(obj => Object.keys(obj)))];
			const data_export = data_graph.map(obj => { keys_export.forEach(key => { if (!(key in obj))obj[key] = 0; }); return obj; });
			
			let exporting = am5plugins_exporting.Exporting.new(root, {
				menu: am5plugins_exporting.ExportingMenu.new(root, { }),
				dataSource: data_export,
				numericFields: categories,
				numberFormat: "#,###",
				dateFields: ['name'],
				dateFormat: _xAxisDateFormat,
				filePrefix:props?.name ?? 'chart',
				dataFields: {...{"name":i18n("Date"),...categories_export}},
				dataFieldsOrder: ["name", ...categories],
				...export_data
			});
			exporting.get("menu").set("items",  setMenuExport(props.intl));
		}

		const is_step = props?.stepped ?? false;
		const as_column = props?.column ?? false;
		const with_lineseries = props?.totalLine ?? false;
		const display_legend = props?.legend ?? true;

		const sumas = data_graph.reduce((acumulador, objetoActual) => {
			Object.keys(objetoActual).forEach(clave => {
				if(!['name','Total'].includes(clave))acumulador[clave] = (acumulador[clave] || 0) + parseInt(objetoActual[clave]);
			});
			return acumulador;
		  }, {});

		xAxisRef.current = xAxis;

		categories.map((category, index) => {
			let _itemkey = category;
			if(_itemkey == 'entries' && has_ranking)_itemkey = 'entries_ranking';
			let _label_name = i18n(((texts[_itemkey] != undefined) ? texts[_itemkey] : _itemkey));
			const color = (_label_name == "Total" && props.main_bar_color != undefined) ? am5.color(`rgba(${cssVar(props.main_bar_color)}, 1)`) : getCategoryColor(category, index);
			
			if(category == 'explanation')return category;
			const series_props = {};
			let seriesGraph = 'LineSeries';
			if(as_column && with_lineseries == _itemkey){
				series_props.layer = categories.length;//zIndex
			}else if(as_column){
				seriesGraph = 'ColumnSeries';//per grafics de data amb columnes
				series_props.stacked = true;
			}
			else if(is_step) seriesGraph = 'StepLineSeries';
			
			xy_seriesRef.current[index] = chart.series.push(
				am5xy[seriesGraph].new(root, {
					name:category,
					legendLabelText:_label_name + (sumas[category] != undefined ? `: [bold]${milesNumber(sumas[category],0)}[/]`: ''),
					xAxis,
					yAxis,
					valueYField:category,
					valueXField:'name',
					//connect:false,
					//fill:color,
					stroke:color,
					fill: color,  // Color de fondo
					label:`${_label_name}`,
					tooltip:am5.Tooltip.new(root, {
						pointerOrientation: "horizontal",
						labelText:'{explanation}[bold]{label}[/]: {valueY}',
					}),
					...series_props
				})
			);

			if(as_column && with_lineseries == _itemkey){
				xy_seriesRef.current[index].strokes.template.setAll({
					strokeWidth: 2,
				});
			}

			xy_seriesRef.current[index].bullets.push(function(root, series, dataItem) {
				if(as_column && with_lineseries == _itemkey){
					return am5.Bullet.new(root, {
						sprite: am5.Circle.new(root, {
						  strokeWidth: 2,
						  stroke: am5.color(`rgba(${cssVar('--ep-black-color')}, 1)`),
						  radius: 2,
						  //fill: root.interfaceColors.get("background")
						})
					  });
				}else if (dataItem.dataContext.explanation) { // Condició específica
					return am5.Bullet.new(root, {
						sprite:am5.Circle.new(root, {
							radius:5,
							fill:am5.color(`rgba(${cssVar('--ep-red-color')}, 1)`),
						})
					});
				}else{
					return am5.Bullet.new(root, {
						sprite:am5.Circle.new(root, {
							radius:2,
							fill:xy_seriesRef.current[index].get('fill'),
						})
					});
				}
				return undefined; // No mostrar bullet si la condición no se cumple
			});

			if(!as_column){
				xy_seriesRef.current[index].strokes.template.setAll({
					strokeWidth: 1.5,
				});
			}
			  
		});

		var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
			xAxis,
			behavior: "zoomX"
		}));
		cursor.lineY.set("visible", false);

		const scrollbarX = am5.Scrollbar.new(root, {
			orientation:'horizontal',
		});
		chart.set('scrollbarX', scrollbarX);
		chart.bottomAxesContainer.children.push(scrollbarX);

		if(categories.length > 1) {
			let legend = chart.children.push(am5.Legend.new(root, {
				centerY:am5.percent(50),
				y:am5.percent(50),
				x:am5.percent(82.5),
				width:am5.percent(30),
				layout:root.verticalLayout,
				height: am5.percent(100),
				verticalScrollbar: am5.Scrollbar.new(root, {
					orientation: "vertical",
				}),
				visible: display_legend
			}));
			legend.data.setAll(chart.series.values);
		}

		return () => {
			root.dispose();
		};
	}, [graph]);

	useLayoutEffect(() => {
		if(['date','prizes_date','month','year','date500','month500','year500','date500total','month500total','year500total','date_total','month_total','year_total'].includes(graph_type)){
			var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const timezoneOffsetInMinutes = new Date().getTimezoneOffset();
			const data_graph_offset = [];
			//Apply offset
			data_graph.map((item, index) => {
				data_graph_offset[index] = {...item, name:(parseInt(item['name']) + (timezoneOffsetInMinutes * 1000  * 60))}
			});
			xAxisRef.current.data.setAll(data_graph_offset);
			for(let index = 0; index < xy_seriesRef.current.length; index++) {
				xy_seriesRef.current[index].data.setAll(data_graph_offset);
			}
		}else{
			xAxisRef.current.data.setAll(data_graph);
			for(let index = 0; index < xy_seriesRef.current.length; index++) {
				xy_seriesRef.current[index].data.setAll(data_graph);
			}
		}

		
	}, [props.data]);

	return (
		<div id={props?.name ?? 'line_chart'} class="custom-graph" style={props?.graph_styles ?? default_graph_styles} />
	)
};

const BarChart = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const graph = props.state?.graph ?? false;
	const has_ranking = props?.promotion?.has_ranking ?? false;
	const data_graph = props.data;
	const xAxisRef = useRef(null);
	const xy_seriesRef = useRef([]);
	const display_legend = props?.legend ?? true;
	let root;

	useLayoutEffect(() => {
		if(!am5.Root) return;

		root = mainChartSetup(props?.name ?? 'bar_chart', props.initChart, props.loadedChart);

		let chart = root.container.children.push(
			am5xy.XYChart.new(root, {
				panY:false,
				layout:root.horizontalLayout,
				maxTooltipDistance:-1,
			})
		);

		let yAxis = chart.yAxes.push(
			am5xy.ValueAxis.new(root, {
				renderer:am5xy.AxisRendererY.new(root, {}),
			})
		);

		let xAxis = chart.xAxes.push(
			am5xy.CategoryAxis.new(root, {
				renderer:am5xy.AxisRendererX.new(root, {
					minGridDistance:1,
					cellStartLocation:0.2,
					cellEndLocation:0.8,
				}),
				categoryField:'name',
				tooltip:am5.Tooltip.new(root, {}),
			})
		);


		let categories = [];
		data_graph.map((object) => {
			for(const property in object) {
				if(property == 'name') continue;
				if(categories.indexOf(property) > -1) continue;
				categories.push(property);
			}
		});

		const enable_export = props?.export ?? true;
		if(enable_export){
			const categories_export = Object.fromEntries(categories.map((valor, index) => [`${valor}`, (!['Total','Accepted'].includes(valor) ? `"${i18n(valor)}"` : i18n(valor))]));
			const keys_export = [...new Set(data_graph.flatMap(obj => Object.keys(obj)))];
			const data_export = data_graph.map(obj => { keys_export.forEach(key => { if (!(key in obj))obj[key] = 0; }); return obj; });
			
			let exporting = am5plugins_exporting.Exporting.new(root, {
				menu: am5plugins_exporting.ExportingMenu.new(root, { }),
				dataSource: data_export,
				numericFields: categories,
				numberFormat: "#,###",
				filePrefix:props?.name ?? 'chart',
				dataFields: {...{"name":i18n("Date"),...categories_export}},
				dataFieldsOrder: ["name", ...categories],
				...export_data
			});
			exporting.get("menu").set("items",  setMenuExport(props.intl));
		}


		xAxisRef.current = xAxis;
		categories.map((category, index) => {
			const color = getCategoryColor(category, index);
			let _itemkey = category;
			if(_itemkey == 'entries' && has_ranking)_itemkey = 'entries_ranking';
			const _label_name = i18n(((texts[_itemkey] != undefined) ? texts[_itemkey] : _itemkey));
			xy_seriesRef.current[index] = chart.series.push(
				am5xy.ColumnSeries.new(root, { 
					name: category,
					xAxis: xAxis, 
					yAxis: yAxis, 
					categoryXField:'name',
					valueYField: category, 
					stacked: true,
					fillField:'fill',
					fill:color,
					stroke:color,
					tooltip: am5.Tooltip.new(root, {
						labelText:`[bold]${_label_name}[/]: {valueY}`,
					})
				  })
			);
			xy_seriesRef.current[index].columns.template.setAll({
				tooltipText:(categories.length > 1) ? '[bold]{label}[/]: {valueY}' : '{valueY}',
				tooltipY:am5.percent(10),
			});
		});

		if(categories.length > 1) {
			let legend = chart.children.push(am5.Legend.new(root, {
				centerY:am5.percent(50),
				y:am5.percent(50),
				x:am5.percent(82.5),
				width:am5.percent(30),
				layout:root.verticalLayout,
				height: am5.percent(100),
				verticalScrollbar: am5.Scrollbar.new(root, {
					orientation: "vertical",
				}),
				visible: display_legend
			}));

			legend.data.setAll(chart.series.values);
		}

		return () => {
			root.dispose();
		};
	}, [graph]);

	// This code will only run when props.data changes
	useLayoutEffect(() => {
		(xAxisRef.current).data.setAll(data_graph);
		for(let index = 0; index < xy_seriesRef.current.length; index++) {
			(xy_seriesRef.current[index]).data.setAll(data_graph);
		}
	}, [props.data]);

	return (
		<div id={props?.name ?? 'bar_chart'} class="custom-graph" style={props?.graph_styles ?? default_graph_styles} />
	)
};

const SimpleTable = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const _table = props.data;
	const _values = convertObjectToArray(_table?.values ?? _table);
	_values.sort((a, b) => {
		return parseInt(a.total) > parseInt(b.total) ? -1 : 1;
	});
	const has_ranking = props?.promotion?.has_ranking ?? false;
	const is_sweep = (props?.active?.key ?? 'promotion') == 'sweep';
	const is_promotion_emails = (props?.active?.key ?? 'promotion') == 'promotion_emails';
	return (
		<>
			{(_table.total != undefined && false) && (
				<SectionSubtitle autotranslate={false}>{i18n("Total")} <strong>{_table.total}</strong></SectionSubtitle>
			)}

			<table class='gui_generic_table gui_simple_table gui_not_in_top' cellPadding='0' cellSpacing='0'>
				<thead>
					<tr>
						<th>{is_promotion_emails ? i18n("Statistics") : (is_sweep ? i18n("Name or Profile") : i18n("Page"))}</th>
						<th class="number_data">{is_promotion_emails ? i18n("Total") : (is_sweep ? i18n("Participations") : i18n("Views"))}</th>
					</tr>
				</thead>

				<tbody>
					{(_values).map((item, i) => {
						let _subapartat = false;
						if(item.apts) {
							_subapartat = convertObjectToArray(item.apts).sort((a, b) => {
								return parseInt(a.total) > parseInt(b.total) ? -1 : 1;
							});
						}
						let _itemkey = item.key;
						if(_itemkey == 'entries' && has_ranking)_itemkey = 'entries_ranking';
						let participant_name = item?.name ?? i18n(((texts[_itemkey] != undefined) ? texts[_itemkey] : _itemkey));
						if(item.network == 'instagram') participant_name = `@${participant_name}`;

						const _class = (is_sweep && item.network != undefined) ? `ep-${item.network}` : false;

						return (
							<React.Fragment key={`row_${i}`}>
								<tr>
									<td class={_class ? _class : ''}>{participant_name}</td>
									<td class="number_data">{item?.total ?? 0}</td>
								</tr>

								{_subapartat && _subapartat.map((item2, i2) => {
									let _sublabel = texts[item2.key] != undefined ? i18n(texts[item2.key]) : (texts[item2.name] != undefined ? i18n(texts[item2.name]) : (item2?.name ?? i18n("Unknown")));
									return (
										<tr key={`subrow_${i}_${i2}`}>
											<td>
												<span class='knk-minus gui_small_icon'>{_sublabel}</span>
											</td>

											<td class="number_data">{item2?.total ?? 0}</td>
										</tr>
									)
								})}
							</React.Fragment>
						)
					})}
				</tbody>
			</table>
		</>
	)
};

const RedemptionTable = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const _table = props.data;
	const _values = convertObjectToArray(_table);
	_values.sort((a, b) => {
		return parseInt(a.won) > parseInt(b.won) ? -1 : 1;
	});
	return (
		<>
			<table class='gui_generic_table gui_simple_table gui_not_in_top' cellPadding='0' cellSpacing='0'>
				<thead>
					<tr>
						<th>{i18n("Prizes")}</th>
						<th class="number_data">{i18n("Given")}</th>
						<th class="number_data">{i18n("***Redeemed")}</th>
						<th class="number_data">{i18n("Rate")}</th>
					</tr>
				</thead>

				<tbody>
					{(_values).map((item, i) => {
						return (
							<React.Fragment key={`row_${i}`}>
								<tr>
									<td>{item?.name ?? i18n("Unknown")}</td>
									<td class="number_data">{item?.won ?? 0}</td>
									<td class="number_data">{item?.redeemed ?? 0}</td>
									<td class="number_data">{item?.redemption_pct ?? 0}%</td>
								</tr>
							</React.Fragment>
						)
					})}
				</tbody>
			</table>
		</>
	)
};

const LeveledTable = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const _table = props.data;

	const TableDataGroup = ({ item, level }) => {
		const [ is_opened, setIsOpened ] = useState(false);

		let _children = null;
		{Object.keys(item).map((key) => {
			//skip no children values, only ep1,ep2 i ep3 descendants
			if(key != 'ep1' && key != 'ep2' && key != 'ep3') return;
			if(item[key] == '' || Object.keys(item[key]).length == 0) return;

			_children = item[key];
		})}

		return (
			<>
				<tr>
					<td>
						{(_children != undefined) ? (
							<ActionLink
								icon={(!is_opened) ? 'knk-arrow-r-big' : 'knk-arrow-b-big'}
								_class={{ other:'gui_small_icon' }}
								onClick={() => setIsOpened(!is_opened)}
							>{item.key}</ActionLink>
						) : (
							<span class='knk-minus gui_small_icon'>{item.key}</span>
						)}
					</td>

					<td class="number_data">{item.total}</td>

					<td class="number_data">{item.percent_abs}%</td>
				</tr>

				{(is_opened) && (
					<tr class="is_sublevel">
						<td colSpan={3} class="simple_container">
							<Source
								data={_children}
								level={level + 1}
							/>
						</td>
					</tr>
				)}
			</>
		);
	};
	
	const Source = ({ data, level }) => {
		if(!data || data == '' || data.length == 0) return null;
		const _values = convertObjectToArray(data);

		if(level == 0) {
			return (
				<tbody>
					{_values.map((item, i) => {
						return (
							<TableDataGroup
								key={`item_${i}`}
								item={item}
								level={level}
							/>
						)
					})}
				</tbody>
			)
		}

		return (
			<table class={`level_${level}`} cellPadding='0' cellSpacing='0'>
				<tbody>
					{_values.map((item, i) => {
						return (
							<TableDataGroup
								key={`item_${i}`}
								item={item}
								level={level}
							/>
						)
					})}
				</tbody>
			</table>
		);
	}

	return (
		<table class='gui_generic_table gui_leveled_table gui_not_in_top' cellPadding='0' cellSpacing='0'>
			<thead>
				<tr>
					<th>{i18n("Concept")}</th>

					<th class="number_data">{i18n("Total")}</th>

					<th class="number_data">{i18n("Percentage")}</th>
				</tr>
			</thead>

			<Source
				data={_table}
				level={0}
			/>
		</table>
	)
};

const InsightsElements = (props) => {
	useCSS('comp/tables.css');
	useCSS('comp/custom_stat_items.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const graphs = props?.graphs ?? {};
	const loaded = props?.loaded ?? false;

	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'SET_GRAPH':
				return { ...state, graph:action.graph };

			case 'NEW_REFRESH':
				return { ...state, refresh:state.refresh + 1 };

			default:
				return state;
		}
	}, {
		graph:'graph_1',
		refresh:0,
	});

	useEffect(() => {
		if(Object.keys(graphs).length == 0) return;
		dispatch({ type:'NEW_REFRESH' });
	}, [ props.graphs ]);

	if(!loaded) {
		return (
			<div class="is_fullscreen relative_to_container">
				<Spinner
					_class={{other:'gui_pos_rel_important'}}
					force_bg={true}
				>Loading stats</Spinner>
			</div>
		)
	}
	
	let Component = null;
	const _actual_chart = graphs[state.graph] ?? {};

	const component_props = {};
	if(props.name) component_props.name = props.name;
	if(props.export) component_props.export = props.export;
	if(_actual_chart.column) component_props.column = _actual_chart.column;
	if(_actual_chart.legend != undefined) component_props.legend = _actual_chart.legend;
	if(_actual_chart.totalLine != undefined) component_props.totalLine = _actual_chart.totalLine;
	if(props.main_bar_color != undefined) component_props.main_bar_color = props.main_bar_color;
	if(props.initChart != undefined) component_props.initChart = props.initChart;
	if(props.loadedChart != undefined) component_props.loadedChart = props.loadedChart;

	switch(_actual_chart.type) {
		case 'pie':
			Component = PieChart;
			component_props.limit_slices = props.limit_slices;

			_actual_chart.data.map((item, i) => {
				if(item.name == undefined) return;
				_actual_chart.data[i].name = i18n(item.name);
			});
			break;

		case 'line':
			Component = LineChart;

			_actual_chart.data.map((item, i) => {
				if(item.name == undefined) return;
				_actual_chart.data[i].name = parseInt(item.name); //Data, evitem un string
			});
			break;

		case 'column':
		case 'column_horizontal':
			Component = BarChart;
			
			_actual_chart.data.map((item, i) => {
				if(item.name == undefined) return;
				_actual_chart.data[i].name = i18n(item.name);
			});
			break;

		case 'table':
		case 'table_visits':
			Component = SimpleTable;
			break;

		case 'table_sources':
			Component = LeveledTable;
			break;

		case 'table_redemption':
		case 'redemption_table':
			Component = RedemptionTable;
			break;
	}

	const total_graphs = (isArray(graphs)) ? graphs.length : Object.keys(graphs).length;

	const wrapper_props = {
		updated:props.updated,
		state,
		dispatch,
		graphs,
		extra:props.extra,
		display_total:props.display_total,
		display_last_update:props.display_last_update,
		active:props?.active ?? {},
		display_header:props.display_header,
		timezone:props?.promotion?.timezone ?? 'Europe/Madrid',
		intl:props.intl,
	};
	if(!loaded || total_graphs == 0) {

		const no_data_message = props?.no_data_message ?? i18n("No data");

		return (
			<ChartWrapper
				{...wrapper_props}
			>
				<div dangerouslySetInnerHTML={{ __html:no_data_message}}  class="not_in_top gui_flexbox gui_flex_center gui_flex_align_center gui_text_align_center" style={{minHeight:'calc(100% - 80px)'}}/>
			</ChartWrapper>
		)
	}

	return (
		<ChartWrapper
			{...wrapper_props}
		>
			<Component
				state={state}
				data={_actual_chart.data}
				title={_actual_chart.title}
				intl={props.intl}
				promotion={props.promotion}
				active={props?.active ?? {}}
				{...component_props}
				graph_styles={props.graph_styles}
			/>
		</ChartWrapper>
	)
};

export default injectIntl(InsightsElements);